import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store';
import { useSingInMethodMutation, useUserVerifyMutation } from '../../services/singnin.service';
import { dynamicCustomEventTracking } from '../../lib/gtm';

const userQuickAccessUserVerify = () => {
  const navigate = useNavigate();
  const [verifyUser, { data: oyanaRecurrentData, error: oyanaRecurrentError, isLoading: oyanaRecurrentIsLoading }] =
    useUserVerifyMutation();
  const [singInMethod, { data: signInMethodData, error: errorSignInMethod, isLoading: signInMethodIsLoading }] =
    useSingInMethodMutation();
  const {
    personalDataInfo: { cpf }
  } = useSelector((state: RootState) => state);

  const handleUserVerify = async () => {
    const formatCpf = cpf.replace(/\D/g, '');
    verifyUser({
      cpf: formatCpf
    });
  };

  useEffect(() => {
    if (oyanaRecurrentData) {
      const { oyanaid } = oyanaRecurrentData;
      dynamicCustomEventTracking.send({ dynamicEventName: `journey_quick_access_phone_ag` });
      singInMethod({
        id: oyanaid,
        method: 'phone'
      });
    }
    if (oyanaRecurrentError) {
      dynamicCustomEventTracking.send({ dynamicEventName: 'journey_quick_access_error_cpf_not_found_ag' });
      navigate('/dados-pessoais');
    }
  }, [oyanaRecurrentData, oyanaRecurrentError]);

  useEffect(() => {
    if (signInMethodData) {
      navigate('/acesso-rapido/codigo', { state: { dataMethod: signInMethodData } });
    }
    if (errorSignInMethod) {
      console.log('fazer tratamento de erro');
    }
  }, [signInMethodData, errorSignInMethod]);

  return {
    oyanaRecurrentData,
    oyanaRecurrentError,
    signInMethodData,
    errorSignInMethod,
    oyanaRecurrentIsLoading,
    signInMethodIsLoading,
    handleUserVerify
  };
};

export default userQuickAccessUserVerify;
